'use strict';
const angular = require('angular');

import { ISeasonUtilsService, IPickupUtilsService, IPickupOption, IPickupEvent, ISeason } from '../../interfaces';

/*@ngInject*/
export class PickupUtilsService implements IPickupUtilsService{
    SeasonUtils: ISeasonUtilsService;
    TranslationService;
    getDateForInterval: Function;

    constructor(SeasonUtils: ISeasonUtilsService, TranslationService)
    {
        this.SeasonUtils = SeasonUtils;
        this.getDateForInterval = SeasonUtils.getDateForInterval;
        this.TranslationService = TranslationService;
    }

    public getStartDateFor(season: ISeason, pickupOption: IPickupOption, pickupEvent: IPickupEvent) {
        if (!pickupEvent.startDateOverride) {
            let startTime = this.SeasonUtils.getDateForInterval(season, pickupEvent.eventNumber);
            startTime.setDate(startTime.getDate() + pickupOption.weekDay);
            startTime.setMinutes(pickupOption.startMinute);
            return startTime;

        } else {
            return new Date(pickupEvent.startDateOverride);
        }
    }

    public getEndDateFor(season: ISeason, pickupOption: IPickupOption, pickupEvent: IPickupEvent) {
        let durationMinutes = pickupEvent.durationMinutesOverride || pickupOption.durationMinutes;
        if (!pickupEvent.startDateOverride) {
            let endTime = this.SeasonUtils.getDateForInterval(season, pickupEvent.eventNumber);
            endTime.setMinutes(pickupOption.startMinute + durationMinutes);
            return endTime;

        } else {
            return new Date(new Date(pickupEvent.startDateOverride).getTime() + 60000 * durationMinutes);
        }
    }

    /**
     * Get the name day
     * @param pickupOption 
     */
    public getPickupDay(season: ISeason, pickupOption: IPickupOption) {
        if (!pickupOption || !season) {
            return null;
        }

        let firstDate = new Date(season.firstEventDate);
        let numberDay = (firstDate.getDay() + pickupOption.weekDay) % 7;

        let day = '';
        switch(numberDay) {
            case 0:
                day = this.TranslationService.translate('day_0');
                break;
            case 1:
                day = this.TranslationService.translate('day_1');
                break;
            case 2:
                day = this.TranslationService.translate('day_2');
                break;
            case 3:
                day = this.TranslationService.translate('day_3');
                break;
            case 4:
                day = this.TranslationService.translate('day_4');
                break;
            case 5:
                day = this.TranslationService.translate('day_5');
                break;
            case 6:
                day = this.TranslationService.translate('day_6');
                break;
        }
        
        return day;
    }

    /**
     * Get the pickup START time in string
     * @param pickupOption 
     */
    public getStartTime(pickupOption: IPickupOption) {
        if (!pickupOption) {
            return null;
        }

        let minutes = Math.floor( pickupOption.startMinute / 60 );
        let seconds = Math.round( pickupOption.startMinute % 60 );

        return this.padNumber(minutes) +':'+ this.padNumber(seconds);
    }

    /**
     * Get the pickup END time in string
     * @param pickupOption 
     */
    public getEndTime(pickupOption: IPickupOption) {
        if (!pickupOption) {
            return null;
        }

        let totalMinutes = pickupOption.startMinute + pickupOption.durationMinutes;
        let minutes = Math.floor( totalMinutes / 60 );
        let seconds = Math.round( totalMinutes % 60 );

        return this.padNumber(minutes) +':'+ this.padNumber(seconds);
    }

    private padNumber(n) {
        return n > 9 ? "" + n: "0" + n;
    }

}


export default angular.module('terrappApp.pickupUtils', [])
.service('PickupUtils', PickupUtilsService)
.name;



// WEBPACK FOOTER //
// ./client/app/services/pickupUtils/pickupUtils.service.ts